import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";
import Reveal from "../components/Reveal";
import { LOCATIONS } from "../lib/content";

const WB = LOCATIONS["west-branch"];

/** The live page is a gallery of listing sheets with no body copy at all. Each
 *  sheet's own details and price are inside the image, so nothing is transcribed
 *  here -- we show the marina's sheets and leave enquiries to the phone. */
const LISTINGS = [
  "/site-assets/boats-for-sale/listing-2026-1.png",
  "/site-assets/boats-for-sale/listing-2026-2.png",
  "/site-assets/boats-for-sale/listing-2026-3.png",
  "/site-assets/boats-for-sale/listing-2026-6.png",
  "/site-assets/boats-for-sale/listing-2024-2.png",
];

export default function BoatsForSale() {
  return (
    <>
      <Seo
        title="Boats For Sale | West Branch Marina"
        description="Boats for sale at West Branch Marina."
        path="/boats-for-sale"
      />

      <PageHero eyebrow="Boats For Sale" title="Boats For Sale" />

      <Section tone="white">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {LISTINGS.map((src, i) => (
            <Reveal key={src} delay={i * 70}>
              <a
                href={src}
                target="_blank"
                rel="noreferrer"
                data-testid={`boat-listing-${i + 1}`}
                className="block overflow-hidden rounded-3xl border border-sand-border bg-sand transition-transform hover:-translate-y-1"
              >
                <img
                  src={src}
                  alt={`Boat for sale listing ${i + 1}`}
                  className="w-full object-contain"
                  loading="lazy"
                />
              </a>
            </Reveal>
          ))}
        </div>
        <p data-testid="boats-for-sale-contact" className="mt-12 text-sm text-slate-600">
          <a href={WB.phoneHref} data-testid="boats-for-sale-call-link" className="font-bold text-ember hover:underline">
            {WB.phone}
          </a>
        </p>
      </Section>
    </>
  );
}
